import { DockView, split, tabs, useDockManager } from "@tredespace/ui/dockable";
import { type JSX, useEffect } from "react";
import { useAppHotkeys } from "./components/hooks/useAppHotkeys.ts";
import { PANEL_IDS, scaffolderPanels } from "./components/panels.tsx";
import { getEngine } from "./state/engine/engine.actions.ts";
import { runGenerator } from "./state/generator/generator.actions.ts";
import { bindDockManager } from "./state/layout/layout.actions.ts";

/** Height of the locked ribbon strip, px. */
const RIBBON_HEIGHT_PX = 116;

export function App(): JSX.Element {
  useAppHotkeys();

  const manager = useDockManager(() => ({
    panels: scaffolderPanels,
    layout: split("column", [
      tabs([PANEL_IDS.ribbon], {
        id: "top",
        hideTabs: true,
        locked: true,
        fixedSize: RIBBON_HEIGHT_PX,
      }),
      split(
        "row",
        [
          tabs([PANEL_IDS.generator, PANEL_IDS.reference, PANEL_IDS.planes], { id: "left" }),
          tabs([PANEL_IDS.viewport], { id: "center" }),
          split(
            "column",
            [tabs([PANEL_IDS.bom], { id: "right" }), tabs([PANEL_IDS.jacks], { id: "rightBottom" })],
            [70, 30],
          ),
        ],
        [20, 56, 24],
      ),
    ]),
  }));

  // The engine renders once the canvas exists; the generator gives a model to
  // look at on first paint, and that first state is not undoable.
  useEffect(() => {
    const engine = getEngine();
    runGenerator();
    engine.clearHistory();
  }, []);

  // The ribbon's Reset panels button lives inside the layout it resets.
  useEffect(() => {
    bindDockManager(manager);
  }, [manager]);

  return <DockView manager={manager} className="h-full" />;
}
